import React from "react";
import classNames from "classnames";

const SquareButton = ({ label, Icon, onClick, layout = "left" }) => {
  return (
    <div
      onClick={() => {
        onClick();
      }}
      className={classNames("square-button", layout, "box")}
    >
      <Icon size={22} />
      {label}
    </div>
  );
};

export default SquareButton;
